import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { compareIgnoreCase } from "../../../../utils/helpers.utils";

export default function ListOneColumn(props) {
  const { firstList, secondList, resetFilter, defaultList, handleSelectedData, resetClearData } = props;
  const [firstListValues, setFirstListValues] = useState(firstList);
  const [isSelected, setIsSelected] = useState("");


  const handleOnDragEnd = (result) => {
    
    if (!result.destination) return;
    const items = Array.from(firstListValues);
    const [reorderedItem] = items.splice(result.source.index, 1);   
    items.splice(result.destination.index, 0, reorderedItem);
    setFirstListValues(items);
    if (handleSelectedData) {
      handleSelectedData(items);
    }
  };

 
  const handleMovableList = (e) => {
    setIsSelected(e.currentTarget.id);
  };

  useEffect(() => {
    if (resetFilter) {
      const notDefaultList = secondList?.filter((r) => r.FieldType !== "default") ?? [];

      const availableList = [
        ...firstList,
        ...notDefaultList,
      ].sort((a, b) => compareIgnoreCase(a.FilterName, b.FilterName));

      setFirstListValues(availableList);
      if (handleSelectedData) {
        handleSelectedData(defaultList);
      }
      if (resetClearData) {
        resetClearData(false);
      }
    }
  }, [resetFilter, firstList, secondList, defaultList, handleSelectedData, resetClearData]);

  useEffect(() => {
    if(handleSelectedData) {
        handleSelectedData(firstListValues);
    }
  }, [firstListValues, handleSelectedData]);


  return (
    <div className="list-box-containe w-auto">
      <div className="list-box-header-container w-auto mb-2">
        <div className="list-box-available-container d-flex align-items-center">
          <h1 className="mb-0">Output Columns</h1>
          <span>Drag and drop to reorder item list</span>
        </div>
      </div>
      <div className="list-box-data-container">
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="available">
            {(provided, snapshot) => (
              <div
                className="characters"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {firstListValues.map((item, index) => (
                  <Draggable
                    key={item.FilterId ? item.FilterId.toString() : index.toString()}
                    draggableId={item.FilterId ? item.FilterId.toString() : index.toString()}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        title={item.FilterName}
                        id={item.FilterId}
                        onClick={handleMovableList}
                        className={[
                          isSelected === item.FilterId ? "isSelected" : "",
                          snapshot.isDragging
                            ? "box-shadow-dragging"
                            : "box-shadow-none",
                          "user-select",
                        ].join(" ")}
                      >
                        {item.FilterName}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
}
